// import initialState from "./initialState";
// import { REQUEST_SUBSTITUTE_COACH } from "../constants";

// export default function requestSubstituteReducer(state = initialState.requestSubstituteResponse, action) {
//     if (action.type == REQUEST_SUBSTITUTE_COACH) return action.requestSubstituteResponse;

//   return state;
// }